import { IPoint2d } from '@/editor/math/IPoint2d';
import { Point2dUtils } from '@/editor/math/Point2dUtils';
import { isClockwise } from '@/editor/math/utils';
import { EFaceSide } from '@/editor/types';

export function constructRectRoomWalls(point1: IPoint2d, point2: IPoint2d) {
  const p1 = Point2dUtils.clone(point1);
  const p2 = { x: point1.x, y: point2.y };
  const p3 = Point2dUtils.clone(point2);
  const p4 = { x: point2.x, y: point1.y };
  const points = [p1, p2, p3, p4];
  if (!isClockwise(points)) {
    points.reverse();
  }

  // 保证是从point1开始的顺时针
  const index = points.findIndex((p) => Point2dUtils.equals(p, point1));
  const resultPoints = [...points];
  if (index !== -1) {
    resultPoints.length = 0;
    const len = points.length;
    for (let i = 0; i < len; i++) {
      resultPoints.push(points[(index + i) % len]);
    }
  }

  return resultPoints;
}

export function getWallsString(wallIds: string[]) {
  return [...wallIds].sort().join('-');
}

// 需要保留传入数组的顺序
export function getWallsStringV2(wallIds: string[]) {
  // 先寻找排序最小的，再充该位置开始重拍
  let startIndex = 0;
  for (let i = 0; i < wallIds.length; i++) {
    if (wallIds[i] < wallIds[startIndex]) startIndex = i;
  }

  let prevId = '';
  const filterIds = [];
  for (let i = 0; i < wallIds.length; i++) {
    // 合并id相同的相邻边
    const currentId = wallIds[(i + startIndex) % wallIds.length];
    if (currentId === prevId) continue;

    filterIds.push(currentId);
    prevId = currentId;
  }

  // 去重
  if (filterIds.length > 1 && filterIds[0] === filterIds[filterIds.length - 1]) {
    filterIds.pop();
  }

  return filterIds.join('-');
}

export function getWallSideString(
  params: { wallId?: string; side?: EFaceSide; sepId?: string; sepSide?: EFaceSide }[]
) {
  return getWallSideStrArr(params).join('-');
}

// TODO: 待优化，临时解决弧形交点问题
export function getWallSideStrArr(
  params: { wallId?: string; side?: EFaceSide; sepId?: string; sepSide?: EFaceSide; index?: number }[]
) {
  let wallSides;
  if (params[0]?.sepId) {
    wallSides = params.map((param) => `${param.sepId}-${param.sepSide}${param.index ? `-${param.index}` : ''}`);
  } else {
    wallSides = params.map((param) => `${param.wallId}-${param.side}${param.index ? `-${param.index}` : ''}`);
  }

  return wallSides;
}
